const TECHNOLOGY_NAME_SEPARATORS = /[\s._-]+/g;
const REGEX_METACHARACTERS = /[.*+?^${}()|[\]\\]/g;

export const normalizeTechnologyName = (name: string): string =>
  name.trim().toLowerCase().replace(TECHNOLOGY_NAME_SEPARATORS, '');

export const buildTechnologyNameMatchRegex = (name: string): string => {
  const characters = [...normalizeTechnologyName(name)].map((character) =>
    character.replace(REGEX_METACHARACTERS, '\\$&'),
  );

  if (characters.length === 0) {
    return '^$';
  }

  return `^[\\s._-]*${characters.join('[\\s._-]*')}[\\s._-]*$`;
};
